import { render, staticRenderFns } from "./investorParticularsDetails.vue?vue&type=template&id=0dfee07e&scoped=true"
import script from "./investorParticularsDetails.vue?vue&type=script&lang=js"
export * from "./investorParticularsDetails.vue?vue&type=script&lang=js"
import style0 from "./investorParticularsDetails.vue?vue&type=style&index=0&id=0dfee07e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfee07e",
  null
  
)

export default component.exports